import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  FormArray,
  FormGroup,
} from "@angular/forms";

interface AgendaFormGroup {
  lunesDesde: string;
  lunesHasta: string;
  lunesDesde2: string;
  lunesHasta2: string;
  martesDesde: string;
  martesHasta: string;
  martesDesde2: string;
  martesHasta2: string;
  miercolesDesde: string;
  miercolesHasta: string;
  miercolesDesde2: string;
  miercolesHasta2: string;
  juevesDesde: string;
  juevesHasta: string;
  juevesDesde2: string;
  juevesHasta2: string;
  viernesDesde: string;
  viernesHasta: string;
  viernesDesde2: string;
  viernesHasta2: string;
  sabadoDesde: string;
  sabadoHasta: string;
  sabadoDesde2: string;
  sabadoHasta2: string;
  domingoDesde: string;
  domingoHasta: string;
  domingoDesde2: string;
  domingoHasta2: string;
}

// export function agendaOverlapValidator(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const formArray = control as FormArray;
//     const agendas: AgendaFormGroup[] = formArray.controls.map(
//       (ctrl) => ctrl.value
//     );

//     for (let i = 0; i < agendas.length; i++) {
//       for (let j = i + 1; j < agendas.length; j++) {
//         if (hasOverlap(agendas[i], agendas[j])) {
//           return { agendaOverlap: true };
//         }
//       }
//     }

//     return null;
//   };
// }

// export function agendaOverlapValidator(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const formArray = control as FormArray;
//     const agendas: AgendaFormGroup[] = formArray.controls.map(
//       (ctrl) => ctrl.value
//     );

//     const overlaps: { index1: number; index2: number; agenda1: AgendaFormGroup; agenda2: AgendaFormGroup }[] = [];

//     for (let i = 0; i < agendas.length; i++) {
//       for (let j = i + 1; j < agendas.length; j++) {
//         if (hasOverlap(agendas[i], agendas[j])) {
//           overlaps.push({
//             index1: i,
//             index2: j,
//             agenda1: agendas[i],
//             agenda2: agendas[j]
//           });
//         }
//       }
//     }

//     if (overlaps.length > 0) {
//       return { agendaOverlap: overlaps };
//     }

//     return null;
//   };
// }


// function hasOverlap(
//   agenda1: AgendaFormGroup,
//   agenda2: AgendaFormGroup
// ): boolean {
//   const days = [
//     "lunes",
//     "martes",
//     "miercoles",
//     "jueves",
//     "viernes",
//     "sabado",
//     "domingo",
//   ] as const;

//   for (const day of days) {
//     const desde1 = agenda1[`${day}Desde`];
//     const hasta1 = agenda1[`${day}Hasta`];
//     const desde2 = agenda2[`${day}Desde`];
//     const hasta2 = agenda2[`${day}Hasta`];

//     if (
//       desde1 &&
//       hasta1 &&
//       desde2 &&
//       hasta2 &&
//       isOverlapping(desde1, hasta1, desde2, hasta2)
//     ) {
//       return true;
//     }
//   }

//   return false;
// }

// function isOverlapping(
//   desde1: string,
//   hasta1: string,
//   desde2: string,
//   hasta2: string
// ): boolean {
//   const [hora1, minutos1] = desde1.split(":").map(Number);
//   const [hora2, minutos2] = hasta1.split(":").map(Number);
//   const [hora3, minutos3] = desde2.split(":").map(Number);
//   const [hora4, minutos4] = hasta2.split(":").map(Number);

//   const tiempo1 = hora1 * 60 + minutos1;
//   const tiempo2 = hora2 * 60 + minutos2;
//   const tiempo3 = hora3 * 60 + minutos3;
//   const tiempo4 = hora4 * 60 + minutos4;

//   return tiempo1 < tiempo4 && tiempo3 < tiempo2;
// }

export function agendaOverlapValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formArray = control as FormArray;
    const agendas: AgendaFormGroup[] = formArray.controls.map(
      (ctrl) => ctrl.value
    );

    const overlaps: {
      index1: number;
      index2: number;
      agenda1: AgendaFormGroup;
      agenda2: AgendaFormGroup;
      overlappingDays: string[];
    }[] = [];

    for (let i = 0; i < agendas.length; i++) {
      for (let j = i + 1; j < agendas.length; j++) {
        const overlappingDays = getOverlappingDays(agendas[i], agendas[j]);
        if (overlappingDays.length > 0) {
          overlaps.push({
            index1: i,
            index2: j,
            agenda1: agendas[i],
            agenda2: agendas[j],
            overlappingDays
          });
        }
      }
    }

    if (overlaps.length > 0) {
      return { agendaOverlap: overlaps };
    }

    return null;
  };
}

function getOverlappingDays(
  agenda1: AgendaFormGroup,
  agenda2: AgendaFormGroup
): string[] {
  const days = [
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
    "domingo",
  ] as const;

  const overlappingDays: string[] = [];

  for (const day of days) {
    const tramos1 = tramosDelDia(agenda1, day);
    const tramos2 = tramosDelDia(agenda2, day);

    let pisa = false;
    for (const t1 of tramos1) {
      for (const t2 of tramos2) {
        if (isOverlapping(t1.desde, t1.hasta, t2.desde, t2.hasta)) {
          pisa = true;
          break;
        }
      }
      if (pisa) break;
    }

    if (pisa) overlappingDays.push(day);
  }

  return overlappingDays;
}

function tramosDelDia(agenda: AgendaFormGroup, day: string): Array<{ desde: string; hasta: string }> {
  const tramos: Array<{ desde: string; hasta: string }> = [];
  const d1 = agenda[`${day}Desde`];
  const h1 = agenda[`${day}Hasta`];
  if (d1 && h1) tramos.push({ desde: d1, hasta: h1 });
  const d2 = agenda[`${day}Desde2`];
  const h2 = agenda[`${day}Hasta2`];
  if (d2 && h2) tramos.push({ desde: d2, hasta: h2 });
  return tramos;
}

function isOverlapping(
  desde1: string,
  hasta1: string,
  desde2: string,
  hasta2: string
): boolean {
  const [hora1, minutos1] = desde1.split(":").map(Number);
  const [hora2, minutos2] = hasta1.split(":").map(Number);
  const [hora3, minutos3] = desde2.split(":").map(Number);
  const [hora4, minutos4] = hasta2.split(":").map(Number);

  const tiempo1 = hora1 * 60 + minutos1;
  const tiempo2 = hora2 * 60 + minutos2;
  const tiempo3 = hora3 * 60 + minutos3;
  const tiempo4 = hora4 * 60 + minutos4;

  return tiempo1 < tiempo4 && tiempo3 < tiempo2;
}


export function passwordMatchValidator(g: FormGroup) {
    return g.get("password").value === g.get("repeatPassword").value
      ? null
      : { mismatch: true };
  }

